var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c(_vm.middleware,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }